import { render, staticRenderFns } from "./ContactActionTaskEdit.vue?vue&type=template&id=6ad65110&scoped=true&"
import script from "./ContactActionTaskEdit.vue?vue&type=script&lang=js&"
export * from "./ContactActionTaskEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionTaskEdit.vue?vue&type=style&index=0&id=6ad65110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad65110",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
